/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Network_Vehicle_Operator_NoInputs */

const fr_network_vehicle_operator_no = /** @type {(inputs: Network_Vehicle_Operator_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun opérateur`)
};

const en_network_vehicle_operator_no = /** @type {(inputs: Network_Vehicle_Operator_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No operator`)
};

/**
* | output |
* | --- |
* | "No operator" |
*
* @param {Network_Vehicle_Operator_NoInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_vehicle_operator_no = /** @type {((inputs?: Network_Vehicle_Operator_NoInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Vehicle_Operator_NoInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_vehicle_operator_no(inputs)
	return en_network_vehicle_operator_no(inputs)
});